"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.cModelValueByInputTypeSchema = exports.cInputType = exports.zRepeaterValue = void 0;
var zod_1 = require("zod");
var constants_1 = require("./constants");
/**
 * Inputs might return a `string` when we want a `number`, but it's fine -
 * zod can parse it for us.
 * See https://zod.dev/?id=you-can-use-pipe-to-fix-common-issues-with-zcoerce.
 */
var zNumber = function () {
    return zod_1.z
        .number({
        invalid_type_error: constants_1.formI18nErrors.default,
    })
        .or(zod_1.z.string())
        .pipe(zod_1.z.coerce.number());
};
var zString = function () {
    var _string = zod_1.z.string({
        invalid_type_error: constants_1.formI18nErrors.default,
    });
    return _string;
};
var zUuid = function () {
    var _string = zod_1.z.string({
        invalid_type_error: constants_1.formI18nErrors.default,
    }).uuid();
    return _string;
};
var zArray = function (schema) {
    return zod_1.z.array(schema, {
        invalid_type_error: constants_1.formI18nErrors.default,
    });
};
var zObject = function (schema) {
    return zod_1.z.object(schema, {
        invalid_type_error: constants_1.formI18nErrors.default,
    });
};
var zRecord = function (schema1, schema2) {
    return zod_1.z.record(schema1, schema2, {
        invalid_type_error: constants_1.formI18nErrors.default,
    });
};
var zUnknown = function () {
    return zod_1.z.unknown({
        invalid_type_error: constants_1.formI18nErrors.default,
    });
};
var zRepeaterMeta = function () {
    return zObject({
        fieldId: zString(),
        deleted: zBoolean().optional(),
    });
};
var zRepeaterValue = function () {
    return zod_1.z.object({
        // A better type should be possible
        // — namely, it should be a union of all possible types.
        value: zUnknown(),
        _meta: zRepeaterMeta().optional(),
    }, {
        invalid_type_error: constants_1.formI18nErrors.default,
    });
};
exports.zRepeaterValue = zRepeaterValue;
var zBoolean = function () {
    return zod_1.z.boolean({
        invalid_type_error: constants_1.formI18nErrors.default,
    });
};
var cOptionsSchema = function () {
    return zArray(zString().or(zNumber())).or(zString().or(zNumber()));
};
/**
 * This includes ALL the available input types. Some of which are aliases of one
 * another (for instance, `option` and `tags`, as defined `./constants`.
 */
exports.cInputType = Object.freeze({
    text: 'text',
    textarea: 'textarea',
    textInput: 'textInput',
    stringTemplate: 'stringTemplate',
    hidden: 'hidden',
    number: 'number',
    tel: 'tel',
    password: 'password',
    search: 'search',
    month: 'month',
    year: 'year',
    email: 'email',
    imageUploader: 'imageUploader',
    options: 'options',
    tags: 'tags',
    conditional: 'conditional',
    toggle: 'toggle',
    checkbox: 'checkbox',
    radio: 'radio',
    files: 'files',
    description: 'description',
    geoLocation: 'geoLocation',
    repeater: 'repeater',
    // fieldId: 'fieldId',
    errorMessages: 'errorMessages',
    title: 'title',
    heading: 'heading',
    dateInput: 'dateInput',
    date: 'date',
    // This isn't supported — I found a really old comment saying
    // to add back when duration was supported, so I'm just leaving it
    // here for future reference.
    // duration: 'duration',
    paragraph: 'paragraph',
    i18n: 'i18n',
    userList: 'userList',
    structureSelector: 'structureSelector',
    applicationSelector: 'applicationSelector',
    typeAhead: 'typeAhead',
    timeInput: 'timeInput',
    blockSelector: 'blockSelector',
    dataSchemaSelector: 'dataSchemaSelector',
    colorPicker: 'colorPicker',
    codeEditor: 'codeEditor',
    icon: 'icon',
    iconPicker: 'iconPicker',
    dataMappingSelector: 'dataMappingSelector',
    wysiwyg: 'wysiwyg',
    modal: 'modal',
    fieldPicker: 'fieldPicker',
    userSelector: 'userSelector',
    emailTemplatePicker: 'emailTemplatePicker',
    membershipTags: 'membershipTags',
    membershipTagsSelector: 'membershipTagsSelector',
    ticketEventPicker: 'ticketEventPicker',
});
exports.cModelValueByInputTypeSchema = Object.freeze((_a = {},
    _a[exports.cInputType.text] = zString(),
    _a[exports.cInputType.textarea] = zString(),
    _a[exports.cInputType.textInput] = zString(),
    _a[exports.cInputType.stringTemplate] = zString(),
    _a[exports.cInputType.hidden] = zString(),
    /**
     * Notice `coerce` — it ensures that if we receive
     * a string, zod will parse it as a number and we'll
     * have a number at the end.
     * */
    _a[exports.cInputType.number] = zNumber(),
    _a[exports.cInputType.tel] = zString(),
    _a[exports.cInputType.password] = zString(),
    _a[exports.cInputType.search] = zString(),
    _a[exports.cInputType.month] = zString(),
    // TODO Not sure about this one — check
    // year: zString(),
    _a[exports.cInputType.year] = zNumber(),
    _a[exports.cInputType.email] = zString().email({
        message: constants_1.formI18nErrors.email,
    }),
    _a[exports.cInputType.imageUploader] = zNumber().nullish(),
    _a[exports.cInputType.options] = cOptionsSchema(),
    _a[exports.cInputType.tags] = cOptionsSchema(),
    // TODO what is this really going to be?
    _a[exports.cInputType.conditional] = zString(),
    _a[exports.cInputType.toggle] = zBoolean().or(zArray(zString())),
    // TODO Really? Check.
    // Comment from Tom: checkbox input type should probably also be using 
    // cOptionsSchema, similar to the options input type.Is nullish correct
    // here? What is it checking for?
    _a[exports.cInputType.checkbox] = zArray(zString().nullable().nullish()),
    _a[exports.cInputType.radio] = zString(),
    _a[exports.cInputType.files] = zArray(zNumber()),
    _a[exports.cInputType.description] = zString(),
    _a[exports.cInputType.geoLocation] = zObject({
        lat: zString(),
        lon: zString(),
    }),
    _a[exports.cInputType.repeater] = zArray(zRecord(zString(), (0, exports.zRepeaterValue)()).and(zObject({
        _meta: zRepeaterMeta(),
    }).optional())),
    // [cInputType.fieldId]: zString(),
    _a[exports.cInputType.errorMessages] = zString(),
    _a[exports.cInputType.title] = zString(),
    _a[exports.cInputType.heading] = zString(),
    _a[exports.cInputType.dateInput] = zString(),
    // TODO this should really be either `z.string().date()` or a custom `zDate()`.
    _a[exports.cInputType.date] = zString(),
    _a[exports.cInputType.paragraph] = zString(),
    _a[exports.cInputType.i18n] = zString(),
    _a[exports.cInputType.userList] = zUuid().or(zArray(zUuid())),
    // 👇 I'm not sure this is correct, but it seems fine.
    // 👇 You don't want errors when the value is reset.
    _a[exports.cInputType.structureSelector] = zObject({
        module: zUuid(),
        page: zUuid(),
        block: zArray(zUuid()),
        routerPageName: zString(),
    }).or(zObject({})),
    _a[exports.cInputType.applicationSelector] = zString(),
    _a[exports.cInputType.typeAhead] = zString(),
    _a[exports.cInputType.timeInput] = zString(),
    _a[exports.cInputType.blockSelector] = zString(),
    _a[exports.cInputType.dataSchemaSelector] = zUuid().or(zArray(zUuid())),
    _a[exports.cInputType.colorPicker] = zString(),
    _a[exports.cInputType.codeEditor] = zString(),
    _a[exports.cInputType.icon] = zString(),
    _a[exports.cInputType.iconPicker] = zString(),
    _a[exports.cInputType.dataMappingSelector] = zUuid().or(zArray(zUuid())),
    _a[exports.cInputType.wysiwyg] = zString(),
    _a[exports.cInputType.modal] = zString(),
    _a[exports.cInputType.fieldPicker] = zString(),
    _a[exports.cInputType.userSelector] = zNumber().or(zArray(zNumber())),
    _a[exports.cInputType.emailTemplatePicker] = zString(),
    _a[exports.cInputType.membershipTags] = zString().or(zArray(zString())),
    _a[exports.cInputType.membershipTagsSelector] = zString().or(zArray(zString())),
    _a[exports.cInputType.ticketEventPicker] = zObject({
        integration: zString(),
        eventId: zString(),
    }),
    _a));
